import { Injectable, inject } from '@angular/core'
import { select, Store, Action } from '@ngrx/store'
import * as TutorialVideosSelectors from './tutorial-videos.selectors'
import { GlobalPreferencesFacade } from 'libs/gb-dashboard/shared/data-access-global-preferences/src/lib/+state/global-preferences.facade'

@Injectable({
  providedIn: 'root',
})
export class TutorialVideosFacade {
  private readonly store = inject(Store)
  private readonly globalPreferencesFacade = inject(GlobalPreferencesFacade)

  loaded$ = this.store.pipe(select(TutorialVideosSelectors.selectTutorialVideosLoaded))
  allTutorialVideos$ = this.store.pipe(select(TutorialVideosSelectors.selectAllTutorialVideos))
  selectedTutorialVideos$ = this.store.pipe(select(TutorialVideosSelectors.selectEntity))

  watchedTutorialVideosMap$ = this.globalPreferencesFacade.watchedTutorialVideosMap$
  showingVideo$ = this.store.pipe(select(TutorialVideosSelectors.selectShowingVideo))
  editCreateLoaded$ = this.store.pipe(select(TutorialVideosSelectors.selectEditCreateLoaded))

  dispatch(action: Action) {
    this.store.dispatch(action)
  }
}
